import { render, staticRenderFns } from "./URLModal.vue?vue&type=template&id=ae47dd88&"
import script from "./URLModal.ts?vue&type=script&lang=ts&"
export * from "./URLModal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports